import React, { useEffect, useRef, useState } from 'react';
import * as pdfjs from 'pdfjs-dist';
import { postService } from '../services/api';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();

// Draws each PDF page as an image inside the site, so there is no browser PDF toolbar
// (no download, print or save buttons) and no link to the file itself.
export default function PdfViewer({ file }) {
  const box = useRef(null);
  const [status, setStatus] = useState('Loading PDF...');

  useEffect(() => {
    let cancelled = false;
    let doc;
    const container = box.current;

    (async () => {
      try {
        const bytes = await postService.fileBytes(file);
        doc = await pdfjs.getDocument({ data: bytes }).promise;
        if (cancelled) return;
        setStatus('');
        const width = Math.min(container.clientWidth || 800, 900);
        for (let n = 1; n <= doc.numPages && !cancelled; n++) {
          const page = await doc.getPage(n);
          const base = page.getViewport({ scale: 1 });
          const viewport = page.getViewport({ scale: (width / base.width) * (window.devicePixelRatio || 1) });
          const canvas = document.createElement('canvas');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.className = 'pdf-page';
          canvas.style.width = '100%';
          container.appendChild(canvas);
          await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
        }
      } catch (err) {
        if (!cancelled) setStatus(err.message && err.message !== 'Could not load file' ? err.message : 'Could not open this PDF.');
      }
    })();

    return () => {
      cancelled = true;
      if (doc) doc.destroy();
      container.innerHTML = '';
    };
  }, [file]);

  return (
    <div className="pdf-viewer">
      {status && <p className="pdf-viewer__status">{status}</p>}
      <div ref={box} className="pdf-viewer__pages" />
    </div>
  );
}
